import React, { useEffect, useState } from 'react';

const Hero = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Add loaded class after a short delay for entrance animation
    const timer = setTimeout(() => {
      setLoaded(true);
    }, 300);

    // Parallax effect for hero image
    const handleScroll = () => {
      const scrollPosition = window.pageYOffset;
      const heroImg = document.querySelector('.hero-img');
      
      // Only apply parallax effect on desktop/tablet (not mobile)
      if (heroImg && scrollPosition < window.innerHeight && window.innerWidth > 768) {
        heroImg.style.transform = `translateY(${scrollPosition * 0.2}px)`;
      } else if (heroImg && window.innerWidth <= 768) {
        // Reset transform on mobile to prevent any parallax effect
        heroImg.style.transform = 'none';
      }
    };

    // Handle window resize to reset transform when switching between mobile/desktop
    const handleResize = () => {
      const heroImg = document.querySelector('.hero-img');
      if (heroImg && window.innerWidth <= 768) {
        heroImg.style.transform = 'none';
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <section className={`hero ${loaded ? 'loaded' : ''}`} id="home">
      <div className="hero-content">
        <h1>Transform Your Home's Exterior Today</h1>
        <p>Professional exterior cleaning services that breathe new life into your property. We make every surface shine with attention to detail and eco-friendly solutions.</p>
        <a href="#contact" className="hero-btn">Get a Free Quote</a>
      </div>
      <div className="hero-img"></div>
    </section>
  );
};

export default Hero;